import { render } from "./ContactUsForm.vue?vue&type=template&id=1b1445e5"
import script from "./ContactUsForm.vue?vue&type=script&lang=js"
export * from "./ContactUsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__